import { render, staticRenderFns } from "./SettingsMultimediaChat.vue?vue&type=template&id=7948895f&"
import script from "./SettingsMultimediaChat.vue?vue&type=script&lang=js&"
export * from "./SettingsMultimediaChat.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMultimediaChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports